import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=4b39a206"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"
import style0 from "./changePass.vue?vue&type=style&index=0&id=4b39a206&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports